import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RefMaterialsProvider } from '../../contexts';
import { SidebarLayout } from '../../layouts';
import { PermissionsGuard } from './Components';
import { Loader } from './loader.routes';

const RefMaterialsList = Loader(lazy(() => import('../pages/RefMaterials')));

export const createRefMaterialsRoutes = () => ({
  path: 'ref-materials',
  element: <SidebarLayout />,
  children: [
    {
      path: '',
      element: (
        <PermissionsGuard allowedPermissions={['refMaterialViewAll']} should404>
          <Navigate to="/ref-materials/list" replace />
        </PermissionsGuard>
      )
    },
    {
      path: 'list',
      element: (
        <PermissionsGuard allowedPermissions={['refMaterialViewAll']} should404>
          <RefMaterialsProvider>
            <RefMaterialsList />
          </RefMaterialsProvider>
        </PermissionsGuard>
      )
    }
  ]
});
